const FootballTransition = Object.freeze({
    SkipKickoff: "skipKickoff",
    Start: "start",
    AddPlay: "addPlay",
    Rush: "rush",
    EndOfPlay: "endOfPlay",
    NoPenaltyEndOfPlay: "noPenaltyEndOfPlay",
    OutOfBounds: "outOfBounds",
    Muffed: "muffed",
    Fumble: "fumble",
    FumbleRecovered: "fumbleRecovered",
    FumbleNotRecovered: "fumbleNotRecovered",
    Tackle: "tackle",
    Continue: "continue",
    Returned: "returned",
    Finalize: "finalize",
    PatTry: "patTry",
    PatKick: "patKick",
    PatReturned: "patReturned",
    PatContinued: "patContinued",
    PatRecovered: "patRecovered",
    PatNotRecovered: "patNotRecovered",
    PatPointsNotAwarded: "patPointsNotAwarded",
    PatPointsAwarded: "patPointsAwarded",
    DropKick: "dropKick",
    Kick: "kick",
    CflKick: "cflKick",
    KickOff: "kickOff",
    // Deuce (Indoor Football - kickoff through uprights)
    Deuce: "deuce",
    DeuceGood: "deuceGood",
    DeuceMissed: "deuceMissed",
    // Rebound Net (Indoor Football - ball hits net and stays live)
    HitReboundNet: "hitReboundNet",
    ReboundNetCaughtOffense: "reboundNetCaughtOffense",
    ReboundNetCaughtDefense: "reboundNetCaughtDefense",
    ReboundNetHitGround: "reboundNetHitGround",
    ReboundNetFieldedKicking: "reboundNetFieldedKicking",
    ReboundNetFieldedReceiving: "reboundNetFieldedReceiving",
    // Bar Ball (Indoor Football - kickoff hits goalpost)
    HitGoalpost: "hitGoalpost",
    BarBallRecoveredKicking: "barBallRecoveredKicking",
    BarBallRecoveredReceiving: "barBallRecoveredReceiving",
    NoRecoveryKickReturn: "noRecoveryKickReturn",
    FieldGoal: "fieldGoal",
    FieldGoalFumble: "fieldGoalFumble",
    FieldGoalFakeRun: "fieldGoalFakeRun",
    FieldGoalFakePass: "fieldGoalFakePass",
    FieldGoalGood: "fieldGoalGood",
    FieldGoalMissed: "fieldGoalMissed",
    FieldGoalBlocked: "fieldGoalBlocked",
    FieldGoalOutOfBounds: "fieldGoalOutOfBounds",
    KickOffPenalty: "kickOffPenalty",
    KickOffPenaltyAccepted: "kickOffPenaltyAccepted",
    KickOffPenaltyDeclined: "kickOffPenaltyDeclined",
    Pass: "pass",
    PatPass: "patPass",
    Run: "run",
    PatBlocked: "patBlocked",
    PatCompleted: "patCompleted",
    PatMissed: "patMissed",
    PatIntercepted: "patIntercepted",
    PatFumbled: "patFumbled",
    Rouge: "rouge",
    Downed: "downed",
    TouchBack: "touchBack",
    FairCatch: "fairCatch",
    KickRecovered: "kickRecovered",
    KickNotRecovered: "kickNotRecovered",
    OnSide: "onSide",
    Punt: "punt",
    PuntBlocked: "puntBlocked",
    PuntOutOfBounds: "puntOutOfBounds",
    PassIncomplete: "passIncomplete",
    PassBrokenUp: "passBrokenUp",
    PassDropped: "passDropped",
    PassSacked: "passSacked",
    PassIntercepted: "passIntercepted",
    PassComplete: "passComplete",
    GameControl: "gameControl",
    StartDrive: "startDrive",
    GameStart: "gameStart",
    Spike: "spike",
    StartPeriod: "startPeriod",
    SetTimeAndPeriod: "setTimeAndPeriod",
    Timeout: "timeout",
    UpdateContext: "updateContext",
    CoinToss: "coinToss",
    SwapTeams: "swapTeams",
    Lateral: "lateral",
    Safety: "safety",
    KneelDown: "kneelDown",
    // Fumbled Snap
    FumbledSnap: "fumbledSnap",
    FumbledSnapLost: "fumbledSnapLost",
    FumbledSnapRecovered: "fumbledSnapRecovered",
    // PENALTIES
    Penalty: "penalty",
    SecondPenalty: "secondPenalty",
    PenaltyAccepted: "penaltyAccepted",
    PenaltyDeclined: "penaltyDeclined",
    Offsetting: "offsetting",
    SecondOffsetting: "secondOffsetting",
    StatsCount: "statsCount",
    StatsCountYes: "statsCountYes",
    NoPlay: "noPlay",
    // PLAY PENALTIES
    PlayPenalty: "playPenalty",
    PlayPenaltySecondPenalty: "playPenaltySecondPenalty",
    PlayPenaltyPenaltyAccepted: "playPenaltyPenaltyAccepted",
    PlayPenaltyPenaltyDeclined: "playPenaltyPenaltyDeclined",
    PlayPenaltyOffsetting: "playPenaltyOffsetting",
    PlayPenaltySecondOffsetting: "playPenaltySecondOffsetting",
    PlayPenaltyNoPlay: "playPenaltyNoPlay",
    PlayPenaltyStatsCount: "playPenaltyStatsCount"
});

export default FootballTransition;
